import React from 'react'
import styled from 'styled-components'
import { Text } from 'ui'
import { ServedAd } from './AdBanner'

// Same footprint as CouponCard so the ad sits in the grid like another coupon. The image area
// is 4:3 (440x330 desktop, 329x248 mobile), which is the ratio the admin enforces for the
// coupon_card slot.
const AdCardContainer = styled.a`
display: flex;
width: 472px;
padding: 16px;
flex-direction: column;
gap: 12px;
border-radius: 16px;
background: var(--Neutral-Surface-Minimal, #FFF);
border: 2px solid #FFF;
text-decoration: none;
cursor: pointer;
@media (max-width: 1081px) {
  width: 343px;
  padding: 8px;
  gap: 16px;
}
`

const AdCardImageContainer = styled.div`
width: 100%;
height: 330px;
position: relative;
overflow: hidden;
@media (max-width: 1081px) {
  width: 329px;
  height: 248px;
}
`

const AdCardImage = styled.img`
display: block;
width: 100%;
height: 100%;
object-fit: cover;
`

const SponsoredTag = styled.div`
position: absolute;
top: 20px;
right: 20px;
padding: 4px 10px;
border-radius: 8px;
background: rgba(39, 39, 39, 0.75);
`

const AdCardDetails = styled.div`
display: flex;
padding: 16px;
flex-direction: column;
align-items: flex-start;
align-self: stretch;
`

interface AdCouponCardProps {
  ad: ServedAd
  onClick: () => void
}

const AdCouponCard: React.FC<AdCouponCardProps> = ({ ad, onClick }) => (
  <AdCardContainer
    href={ad.clickUrl || undefined}
    target={ad.clickUrl ? '_blank' : undefined}
    rel={ad.clickUrl ? 'noopener noreferrer' : undefined}
    onClick={e => (ad.clickUrl ? onClick() : e.preventDefault())}
  >
    <AdCardImageContainer>
      <AdCardImage src={ad.imageUrl} alt={ad.name} />
      <SponsoredTag><Text size='sm' weight='bold' textcolor='#FFF'>ממומן</Text></SponsoredTag>
    </AdCardImageContainer>
    <AdCardDetails>
      <Text size='xl' weight='normal' textcolor='#272727' textAlign='right'>{ad.name}</Text>
    </AdCardDetails>
  </AdCardContainer>
)

export default AdCouponCard
